import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import * as React from 'react';

// Add support for the sx prop for consistency with the other branches.
const Anchor = styled('a')({});

export type LinkProps = {
    activeClassName?: string;
    href: string;
    noLinkStyle?: boolean;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
    Omit<MuiLinkProps, 'href'>;

// A styled version of the Link component
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    function Link(props, ref) {
        const {
            activeClassName = 'active',
            className: classNameProps,
            href,
            noLinkStyle,
            ...other
        } = props;

        const className = clsx(classNameProps, {
            [activeClassName]: activeClassName,
        });

        const isExternal =
            typeof href === 'string' &&
            (href.indexOf('http') === 0 || href.indexOf('mailto:') === 0);

        if (isExternal) {
            if (noLinkStyle) {
                return (
                    <Anchor
                        className={className}
                        href={href}
                        ref={ref}
                        {...other}
                    />
                );
            }

            return (
                <MuiLink
                    className={className}
                    href={href}
                    ref={ref}
                    {...other}
                />
            );
        }

        if (noLinkStyle) {
            return (
                <Anchor
                    className={className}
                    href={href}
                    ref={ref}
                    {...other}
                />
            );
        }

        return (
            <MuiLink
                className={className}
                href={href}
                ref={ref}
                {...other}
            />
        );
    },
);

export default Link;
